"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomAddedEventArgs = void 0;
const EventType_1 = require("../EventType");
class RoomAddedEventArgs {
    constructor(roomId) {
        this.roomId = roomId;
        this.__type = EventType_1.EventType.RoomAdded;
        this.__typeName = "RoomAdded";
    }
}
exports.RoomAddedEventArgs = RoomAddedEventArgs;
